import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-0b7789e9"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "bar"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("svg", {
    class: "item-icon item-icon--pause",
    width: "14",
    height: "16",
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M13 6.26844C14.3333 7.03824 14.3333 8.96274 13 9.73254L3.25 15.3617C1.91667 16.1315 0.249999 15.1693 0.249999 13.6297L0.25 2.37133C0.25 0.831728 1.91667 -0.130524 3.25 0.639277L13 6.26844Z",
    fill: "#333333"
  })], -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("svg", {
    class: "item-icon item-icon--play",
    width: "14",
    height: "16",
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [/*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5 2.5C5 1.11929 3.88071 0 2.5 0C1.11929 0 0 1.11929 0 2.5V13.5C0 14.8807 1.11929 16 2.5 16C3.88071 16 5 14.8807 5 13.5V2.5ZM14 2.5C14 1.11929 12.8807 0 11.5 0C10.1193 0 9 1.11929 9 2.5V13.5C9 14.8807 10.1193 16 11.5 16C12.8807 16 14 14.8807 14 13.5V2.5Z",
    fill: "#333333"
  })], -1);
});
var _hoisted_4 = [_hoisted_2, _hoisted_3];
var _hoisted_5 = {
  class: "duration-area"
};
var _hoisted_6 = {
  class: "duration-times guide-target",
  "data-target": "time"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "gap"
  }, "/", -1);
});
var _hoisted_8 = {
  class: "max-duration"
};
var _hoisted_9 = /*#__PURE__*/_createTextVNode(" 停止录制 ");
import { ref, onUnmounted, watch } from 'vue';
import { ScreenMediaService } from '@/services/recordVideo/media.service';
import { RecordVideoService } from '@/services/recordVideo/recordVideo.service';
import { useService } from '@kaokei/use-vue-service';
import { ShowConfirmModal } from '@/views/examination/common/dialog';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var _this = this;
    var screenMediaService = useService(ScreenMediaService);
    var recordVideoService = useService(RecordVideoService);
    var toggleRecording = function () {
      if (!screenMediaService.mediaStream) {
        return _message.error('请先点击开始录制');
      }
      if (screenMediaService.isRecording) {
        pauseRecord();
      } else {
        resumeRecord();
      }
    };
    var moveElRef = ref(null);
    var onMoveStart = function (ev) {
      var moveEl = moveElRef.value;
      if (moveEl) {
        var clientX = ev.clientX,
          clientY = ev.clientY;
        var _a = moveEl.getBoundingClientRect(),
          left = _a.left,
          top = _a.top,
          width_1 = _a.width,
          height_1 = _a.height;
        var offsetX_1 = clientX - left;
        var offsetY_1 = clientY - top;
        var onMove_1 = function (moveEv) {
          var moveX = moveEv.clientX,
            moveY = moveEv.clientY;
          // 获取页面宽高
          var pageWidth = document.documentElement.clientWidth;
          var pageHeight = document.documentElement.clientHeight;
          var calcWidthHalf = width_1 / 2;
          // 计算新的位置
          var newLeft = moveX - offsetX_1 + calcWidthHalf;
          var newTop = moveY - offsetY_1;
          // 限制元素不能超出页面边界
          var limitLenW = width_1 - 0;
          var limitLenH = height_1 - 0;
          newLeft = Math.max(limitLenW - width_1 + calcWidthHalf, Math.min(pageWidth - limitLenW + calcWidthHalf, newLeft));
          newTop = Math.max(limitLenH - height_1, Math.min(pageHeight - limitLenH, newTop));
          moveEl.style.left = "".concat(newLeft, "px");
          moveEl.style.top = "".concat(newTop, "px");
        };
        var onMoveEnd_1 = function () {
          document.removeEventListener('mousemove', onMove_1);
          document.removeEventListener('mouseup', onMoveEnd_1);
        };
        document.addEventListener('mousemove', onMove_1);
        document.addEventListener('mouseup', onMoveEnd_1);
      }
    };
    var startRecord = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!screenMediaService.screenStream) {
                recordVideoService.reGetRecordLogic();
                return [2 /*return*/];
              }
              return [4 /*yield*/, screenMediaService.prepareRecording()];
            case 1:
              _c.sent();
              screenMediaService.start();
              window.hetaoTrack('element_click', {
                elementName: '开始录制',
                pageName: '赛事录屏页面',
                userId: ((_b = (_a = screenMediaService.userService) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userId) || 0,
                uniqueId: screenMediaService.userExamId,
                examId: screenMediaService.examId
              });
              return [2 /*return*/];
          }
        });
      });
    };
    var stopRecord = function () {
      var _a, _b;
      screenMediaService.stop();
      ShowConfirmModal({
        title: '录制完成',
        content: '将为您生成预览文件',
        okLoading: screenMediaService.videoPreviewConfig.spinning
      }).then(function () {
        var _a, _b;
        onCreatePreviewVide();
        window.hetaoTrack('element_click', {
          elementName: '生成录制视频',
          pageName: '赛事录屏页面',
          userId: ((_b = (_a = screenMediaService.userService) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userId) || 0,
          uniqueId: screenMediaService.userExamId,
          examId: screenMediaService.examId
        });
      }).catch(function () {
        var _a, _b;
        screenMediaService.videoPreviewConfig.spinning = false;
        window.hetaoTrack('element_click', {
          elementName: '取消生成录制视频',
          pageName: '赛事录屏页面',
          userId: ((_b = (_a = screenMediaService.userService) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userId) || 0,
          uniqueId: screenMediaService.userExamId,
          examId: screenMediaService.examId
        });
      });
      window.hetaoTrack('element_click', {
        elementName: '停止录制',
        pageName: '赛事录屏页面',
        userId: ((_b = (_a = screenMediaService.userService) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userId) || 0,
        uniqueId: screenMediaService.userExamId,
        examId: screenMediaService.examId
      });
    };
    var onCreatePreviewVide = function () {
      screenMediaService.createPreviewVideo();
    };
    var resumeRecord = function () {
      screenMediaService.resume();
    };
    var pauseRecord = function () {
      screenMediaService.pause();
    };
    watch(function () {
      return screenMediaService.videoPreviewConfig.isMoreThanMaxTime;
    }, function (newVal) {
      if (newVal) {
        screenMediaService.stop();
        ShowConfirmModal({
          title: '时长已达上限',
          content: '点击确认将为您生成预览文件',
          okLoading: screenMediaService.videoPreviewConfig.spinning,
          type: 'warning'
        }).then(function () {
          onCreatePreviewVide();
          screenMediaService.videoPreviewConfig.isMoreThanMaxTime = false;
        }).catch(function () {
          screenMediaService.videoPreviewConfig.isMoreThanMaxTime = false;
        });
      }
    });
    onUnmounted(function () {
      if (screenMediaService.videoPreviewTimer !== null) {
        clearTimeout(screenMediaService.videoPreviewTimer);
      }
    });
    return function (_ctx, _cache) {
      var _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", {
        class: "record-bar-area",
        ref: function (_value, _refs) {
          _refs['moveElRef'] = _value;
          moveElRef.value = _value;
        },
        onMousedown: onMoveStart
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "action-area",
        onClick: toggleRecording,
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["stop"]))
      }, [_createElementVNode("span", {
        class: _normalizeClass(["action-icon_area guide-target", {
          pause: !_unref(screenMediaService).isRecording,
          play: _unref(screenMediaService).isRecording
        }]),
        "data-target": "record-action"
      }, _hoisted_4, 2)], 32), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
        class: _normalizeClass(["current", {
          red: _unref(screenMediaService).isLessThan30Seconds
        }])
      }, _toDisplayString(_unref(screenMediaService).recordFormatTime), 3), _hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(screenMediaService).recordTotalFormatTime), 1)])]), _createElementVNode("div", {
        class: "operate-area",
        onMousedown: _cache[1] || (_cache[1] = _withModifiers(function () {}, ["stop"]))
      }, [_unref(screenMediaService).mediaStream ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        class: "operate",
        type: "primary",
        round: "",
        onClick: stopRecord
      }, {
        default: _withCtx(function () {
          return [_hoisted_9];
        }),
        _: 1
      })) : (_openBlock(), _createBlock(_component_a_button, {
        key: 1,
        class: "operate",
        type: "primary",
        round: "",
        onClick: startRecord,
        loading: _unref(screenMediaService).videoPreviewConfig.spinning
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref(screenMediaService).videoPreviewConfig.spinning ? '视频生成中，请稍后...' : '开始录制'), 1)];
        }),
        _: 1
      }, 8, ["loading"]))], 32)])], 544);
    };
  }
});